<template>
  <div class="tw-divide-y dark:tw-bg-dm tw-h-full tw-divide-gray tw-pb-20">
    <section class="tw-container tw-mx-auto pt-2 tw-flex tw-justify-between tw-items-center">
      <h1 class="tw-text-3xl">
        <span class="color-primary tw-font-semibold">
          iTrack
        </span>
        <span class="tw-opacity-75 tw-font-light">
          style guide
        </span>
      </h1>
      <div>
        <el-switch
          v-model="isDarkMode"
          active-text="Dark mode"
        />
      </div>
    </section>


    <section class="tw-container tw-mx-auto pt-5 mt-7">
      <h2 class="tw-font-bold tw-mb-2">
        Colors
      </h2>
      <div class="tw-flex tw-gap-3 tw-flex-wrap">
        <template
          v-for="(color, index) in colors"
          :key="index"
        >
          <UIKitColorBox
            v-if="color.title"
            :color="color"
          />
          <div
            v-else
            class="Break"
          />
        </template>
      </div>
    </section>

    <section class="tw-container tw-mx-auto pt-5 mt-7">
      <h2 class="tw-font-bold tw-mb-2">
        Typography
      </h2>
      <div>
        <h1>H1 Heading</h1>
        <h2>H2 Heading</h2>
        <h3>H3 Heading</h3>
        <h4>H4 Heading</h4>

        <div class="tw-test-base">
          Text base
        </div>

        <br>

        <a href="#">default link</a>

        <br>

        <button>
          Button
        </button>
      </div>
    </section>

    <section class="tw-container tw-mx-auto pt-5 mt-7">
      <h2 class="tw-font-bold tw-mb-2">
        Buttons
      </h2>
      <div>
        <div class="tw-flex tw-gap-4 tw-mb-6">
          <i-button>Default</i-button>
          <i-button>
            <icon-permit-date />
            With Icon
          </i-button>
          <i-button is-disabled>
            Disabled
          </i-button>
        </div>

        <div class="tw-flex tw-gap-4 tw-mb-6">
          <i-button
            type="primary"
          >
            Primary
          </i-button>
          <i-button
            type="primary"
          >
            <icon-new-permit />
            With Icon
          </i-button>
          <i-button
            type="primary"
            is-disabled
          >
            Disabled
          </i-button>
        </div>

        <div class="tw-flex tw-gap-4 tw-mb-6">
          <i-button
            type="white"
          >
            White
          </i-button>
          <i-button
            type="white"
          >
            <icon-new-permit />
            With Icon
          </i-button>
          <i-button
            type="white"
            is-disabled
          >
            Disabled
          </i-button>
        </div>

        <div class="tw-flex tw-gap-4 tw-mb-6">
          <i-button
            type="transparent"
          >
            Transparent
          </i-button>
          <i-button
            type="transparent"
          >
            <icon-new-permit />
            With Icon
          </i-button>
        </div>

        <div class="tw-flex tw-gap-4 tw-mb-6">
          <i-button-icon-text
            icon="icon-angle-left"
          >
            Default
          </i-button-icon-text>
          <i-button-icon-text
            type="primary"
            icon="icon-angle-left"
          >
            Primary
          </i-button-icon-text>
          <i-button-icon-text
            icon="icon-angle-left"
            size="medium"
          >
            Medium
          </i-button-icon-text>
          <i-button-icon-text
            icon="icon-angle-left"
            size="small"
          >
            Small
          </i-button-icon-text>
        </div>

        <div class="tw-flex tw-gap-4 tw-mb-6">
          <i-button
            type="transparent"
            class="tw-text-primary dark:tw-text-dm-primary hover:tw-text-primary-hover dark:hover:tw-text-dm-primary-hover"
          >
            Transparent
          </i-button>
          <i-button
            type="transparent"
            class="tw-text-primary dark:tw-text-dm-primary hover:tw-text-primary-hover dark:hover:tw-text-dm-primary-hover"
          >
            <icon-new-permit />
            With Icon
          </i-button>
        </div>

        <div class="tw-flex tw-gap-4 tw-mb-6">
          <i-button
            size="large"
          >
            Large
          </i-button>
          <i-button
            size="large"
          >
            <icon-permit-date />
            With Icon
          </i-button>
        </div>

        <div class="tw-flex tw-gap-4 tw-mb-6">
          <i-button
            size="medium"
          >
            Medium
          </i-button>
          <i-button
            size="medium"
          >
            <icon-permit-date />
            With Icon
          </i-button>
        </div>

        <div class="tw-flex tw-gap-4 tw-mb-6">
          <i-button
            size="small"
          >
            Small
          </i-button>
          <i-button
            size="small"
          >
            <icon-permit-date />
            With Icon
          </i-button>
        </div>

        <div class="tw-flex tw-gap-4 tw-mb-6">
          <i-button
            type="default"
            is-icon
          >
            <icon-general-notification />
          </i-button>
          <i-button
            type="primary"
            is-icon
          >
            <icon-general-notification />
          </i-button>
          <i-button
            type="white"
            is-icon
          >
            <icon-general-notification />
          </i-button>

          <i-button
            type="default"
            size="medium"
            is-icon
          >
            <icon-general-notification />
          </i-button>
          <i-button
            type="primary"
            size="medium"
            is-icon
          >
            <icon-general-notification />
          </i-button>
          <i-button
            type="white"
            size="medium"
            is-icon
          >
            <icon-general-notification />
          </i-button>

          <i-button
            type="default"
            size="small"
            is-icon
          >
            <icon-general-notification />
          </i-button>
          <i-button
            type="primary"
            size="small"
            is-icon
          >
            <icon-general-notification />
          </i-button>
          <i-button
            type="white"
            size="small"
            is-icon
          >
            <icon-general-notification />
          </i-button>
        </div>
      </div>
    </section>

    <section class="tw-container tw-mx-auto pt-5 mt-7">
      <h2 class="tw-font-bold tw-mb-2">
        Icons
      </h2>
      <div>
        <div class="tw-flex tw-gap-3 flex-wrap">
          <!--          <div-->
          <!--            v-for="(icon, index) in icons"-->
          <!--            :key="index"-->
          <!--            class="tw-bg-gray-100 tw-shadow tw-px-3 tw-py-2 tw-flex tw-flex-col tw-items-center"-->
          <!--          >-->
          <!--            <div class="tw-w-6 tw-h-6 tw-mb-1.5 tw-flex tw-items-center">-->
          <!--              <component-->
          <!--                :is="icon"-->
          <!--                class="tw-w-full"-->
          <!--              />-->
          <!--            </div>-->
          <!--            <div class="tw-text-sm tw-opacity-70">-->
          <!--              {{ icon }}-->
          <!--            </div>-->
          <!--          </div>-->
        </div>
      </div>
    </section>

    <section class="tw-container tw-mx-auto pt-5 mt-7">
      <h2 class="tw-font-bold tw-mb-2">
        Badges
      </h2>
      <div class="tw-flex tw-gap-4">
        <i-badge>
          Default
        </i-badge>

        <i-badge
          type="primary"
        >
          Primary
        </i-badge>

        <i-badge
          type="warning"
        >
          Warning
        </i-badge>

        <i-badge
          type="success"
        >
          Success
        </i-badge>

        <i-badge
          type="white"
        >
          White
        </i-badge>

        <i-badge is-circle>
          1
        </i-badge>
      </div>
    </section>

    <section class="tw-container tw-mx-auto pt-5 mt-7">
      <h2 class="tw-font-bold tw-mb-2">
        User Avatar
      </h2>
      <div class="tw-flex tw-gap-4 tw-mb-2">
        <i-user-avatar
          size="large"
          fullname="David Veselý"
        />
        <i-user-avatar
          fullname="David Veselý"
        />
        <i-user-avatar
          size="small"
          fullname="David Veselý"
        />
        <i-user-avatar
          size="mini"
          fullname="David Veselý"
        />
      </div>
      <div class="tw-flex tw-gap-4 tw-mb-2">
        <i-user-avatar
          size="large"
          fullname="David Veselý"
          avatar="https://i.pravatar.cc/300"
        />
        <i-user-avatar
          fullname="David Veselý"
          avatar="https://i.pravatar.cc/300"
        />
        <i-user-avatar
          size="small"
          fullname="David Veselý"
          avatar="https://i.pravatar.cc/300"
        />
      </div>
      <div class="tw-flex tw-gap-4 tw-mb-2">
        <i-user-avatar
          size="large"
          fullname="David Veselý"
          :status="20"
        />
        <i-user-avatar
          fullname="David Veselý"
        />
        <i-user-avatar
          size="small"
          fullname="David Veselý"
        />
      </div>
    </section>

    <section class="tw-container tw-mx-auto pt-5 mt-7">
      <h2 class="tw-font-bold tw-mb-2">
        Switch
      </h2>
      <div class="tw-mb-2">
        <el-switch v-model="switchValue" />
        <br>
        <br>
        <el-switch
          v-model="switchValue"
          active-text="Is active"
        />
      </div>
    </section>

    <section class="tw-container tw-mx-auto pt-5 mt-7">
      <h2 class="tw-font-bold tw-mb-2">
        Checkbox
      </h2>
      <div class="tw-mb-2">
        <el-checkbox v-model="checkboxValue" />
        <br>
        <el-checkbox v-model="checkboxValue">
          Is active
        </el-checkbox>
      </div>
    </section>

    <section class="tw-container tw-mx-auto pt-5 mt-7">
      <h2 class="tw-font-bold tw-mb-2">
        Radio
      </h2>
      <div class="tw-mb-2">
        <el-radio
          v-model="radioValue"
          label="1"
        />
        <el-radio
          v-model="radioValue"
          label="2"
        />
      </div>
    </section>

    <section class="tw-container tw-mx-auto pt-5 mt-7">
      <h2 class="tw-font-bold tw-mb-2">
        Input
      </h2>
      <div class="tw-mb-2">
        <el-input
          v-model="inputValue"
          placeholder="Please input"
        />

        <el-input
          v-model="inputValue"
          placeholder="Disabled input"
          disabled
        />

        <el-input
          v-model="inputValue"
          placeholder="Prefix and suffix"
        >
          <template #prefix>
            <icon-general-notification />
          </template>
          <template #suffix>
            <icon-general-notification />
          </template>
        </el-input>

        <el-input
          v-model="inputValue"
          type="textarea"
          placeholder="Please input"
        />
      </div>
    </section>

    <section class="tw-container tw-mx-auto pt-5 mt-7">
      <h2 class="tw-font-bold tw-mb-2">
        Form
      </h2>
      <div class="tw-mb-2">
        <el-form
          ref="form"
          :model="form"
          :rules="formRules"
          label-position="top"
          label-width="120px"
        >
          <i-form-item
            label="Large with inside label"
          >
            <el-input
              v-model="form.name"
            />
          </i-form-item>

          <i-form-item
            label="First name"
            prop="firstName"
          >
            <el-input
              v-model="form.firstName"
            />
          </i-form-item>

          <i-form-item
            label="Select"
          >
            <el-select
              v-model="selectValue"
              placeholder=""
              clearable
            >
              <el-option
                v-for="item in ['A', 'B', 'C']"
                :key="item"
                :label="item"
                :value="item"
              />
            </el-select>
          </i-form-item>
        </el-form>
      </div>
    </section>

    <section class="tw-container tw-mx-auto pt-5 mt-7">
      <h2 class="tw-font-bold tw-mb-2">
        Select
      </h2>
      <div class="tw-mb-2">
        <el-select
          v-model="selectValue"
          placeholder="Select"
        >
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
        <br>
        <el-select
          v-model="selectValue"
          placeholder="Select with groups"
          filterable
          clearable
        >
          <el-option-group
            v-for="group in optionsGroups"
            :key="group.title"
            :label="group.title"
          >
            <el-option
              v-for="item in group.items"
              :key="item"
              :label="item"
              :value="item"
            />
          </el-option-group>
        </el-select>
      </div>
    </section>

    <section class="tw-container tw-mx-auto pt-5 mt-7">
      <h2 class="tw-font-bold tw-mb-2">
        Date picker
      </h2>
      <div class="tw-mb-2">
        <el-date-picker
          v-model="dateValue"
          type="date"
          placeholder="Pick a date"
          format="DD.MM.YYYY"
        />
      </div>
    </section>

    <section class="tw-container tw-mx-auto pt-5 mt-7">
      <h2 class="tw-font-bold tw-mb-2">
        File upload
      </h2>
      <div class="tw-mb-2">
        <i-upload />
      </div>
    </section>

    <section class="pt-5 mt-7">
      <h2 class="tw-container tw-mx-auto tw-font-bold tw-mb-2">
        Tabs
      </h2>
      <div class="tw-border-b tw-border-gray dark:tw-border-dm-gray">
        <div class="tw-container tw-mx-auto">
          <el-tabs
            v-model="tab"
          >
            <el-tab-pane
              label="User"
              name="first"
            />
            <el-tab-pane
              label="Config"
              name="second"
            />
            <el-tab-pane
              label="Role"
              name="third"
            />
            <el-tab-pane
              label="Task"
              name="fourth"
            />
          </el-tabs>
        </div>
      </div>
      <div class="tw-container tw-mx-auto tw-mb-2">
        {{ tab }}
      </div>
    </section>

    <section class="tw-container tw-mx-auto pt-5 mt-7">
      <h2 class="tw-font-bold tw-mb-2">
        Info List Item
      </h2>
      <div class="tw-mb-2">
        <i-info-list-item
          title="Title"
          value="Value"
        />
        <i-info-list-item
          title="Lorem"
        >
          <template #value>
            <span>
              Slot value
            </span>
          </template>
        </i-info-list-item>
      </div>
    </section>

    <section class="tw-container tw-mx-auto pt-5 mt-7">
      <h2 class="tw-font-bold tw-mb-2">
        Popover
      </h2>
      <div class="tw-mb-2">
        <el-popover
          placement="top-start"
          width="200"
          trigger="click"
          content="this is content, this is content, this is content"
        >
          <template #reference>
            <span>
              Click to activate
            </span>
          </template>
        </el-popover>
      </div>
    </section>

    <section class="tw-container tw-mx-auto pt-5 mt-7">
      <h2 class="tw-font-bold tw-mb-2">
        Confirm Popover
      </h2>
      <div class="tw-mb-2">
        <i-confirm-popover
          content="Are you want to delete Daniel Loosbroek?"
        >
          <template #reference>
            <span>
              Click to activate!
            </span>
          </template>
        </i-confirm-popover>
        <br>
        <i-confirm-popover
          trigger="hover"
          placement="top"
          :width="220"
          cancel-text="Close"
          submit-text="OK"
          @cancel="() => false"
          @submit="() => false"
        >
          <template #reference>
            <span>
              Hover to activate!
            </span>
          </template>
          <template #content>
            <div>
              Are you want to delete <strong>Daniel Loosbroek</strong>?
            </div>
          </template>
        </i-confirm-popover>
      </div>
    </section>

    <section class="tw-container tw-mx-auto pt-5 mt-7">
      <h2 class="tw-font-bold tw-mb-2">
        Dialog
      </h2>
      <div class="tw-mb-2">
        <button @click="isDialogOpen = true">
          Open dialog
        </button>
        <el-dialog
          :model-value="isDialogOpen"
          width="30%"
        >
          <span>This is a message</span>
          <template #footer>
            <i-button>Action</i-button>
          </template>
        </el-dialog>
      </div>
    </section>

    <section class="tw-container tw-mx-auto pt-5 mt-7">
      <h2 class="tw-font-bold tw-mb-3">
        StepProgress
      </h2>
      <div class="tw-mb-2">
        <i-step-progress
          :steps="10"
          :active-step="3"
        />
      </div>
    </section>
  </div>
</template>

<script>
import UIKitColorBox from '@/components/ui-kit/UIKitColorBox';

// const iconsRequire = require.context('@/assets/icons/', false, /[a-z]\w+\.(svg)$/);
// const icons = iconsRequire.keys().map((filePath) => filePath.split('/').pop().split('.')[0]);

export default {
  components: {
    UIKitColorBox,
  },
  data() {
    return {
      // icons,
      switchValue: false,
      checkboxValue: false,
      radioValue: false,
      inputValue: '',
      isDarkMode: false,
      options: [{
        value: 'Option1',
        label: 'Option1',
      }, {
        value: 'Option2',
        label: 'Option2',
      }, {
        value: 'Option3',
        label: 'Option3',
      }, {
        value: 'Option4',
        label: 'Option4',
      }, {
        value: 'Option5',
        label: 'Option5',
      }],
      optionsGroups: [
        {
          title: 'Group 1',
          items: [1, 2, 3],
        },
        {
          title: 'Second',
          items: ['A', 'B', 'C'],
        },
      ],
      selectValue: '',
      dateValue: '',
      form: {},
      formRules: {
        firstName: [
          { required: true, message: 'Please input', trigger: 'blur' },
          { min: 3, max: 5, message: 'Length should be 3 to 5', trigger: 'blur' },
        ],
      },
      tab: 'first',
      isDialogOpen: false,
      colors: [
        {
          title: 'white',
          hex: '#FFFFFF',
          blackText: true,
        },
        {
          title: 'black',
          hex: '#000000',
        },

        {},

        {
          title: 'primary',
          hex: '#BB2F56',
        },
        {
          title: 'primary-hover',
          hex: '#AA2A4E',
        },
        {
          title: 'primary-light',
          hex: '#EE798F',
        },
        {
          title: 'primary-lightest',
          hex: '#F4B4CB',
          blackText: true,
        },

        {},

        {
          title: 'secondary',
          hex: '#8D65AE',
        },
        {
          title: 'secondary-light',
          hex: '#C499E7',
        },
        {
          title: 'secondary-lightest',
          hex: '#F7CFFC',
          blackText: true,
        },

        {},

        {
          title: 'dark',
          hex: '#151215',
        },
        {
          title: 'gray-dark',
          hex: '#9591AB',
        },
        {
          title: 'gray',
          hex: '#EAECF3',
          blackText: true,
        },
        {
          title: 'light',
          hex: '#F1F1F8',
          blackText: true,
        },
        {
          title: 'light-hover',
          hex: '#E6E6F2',
          blackText: true,
        },
        {
          title: 'permit-1',
          hex: '#E99C60',
          blackText: true,
        },
        {
          title: 'permit-2',
          hex: '#F798FF',
          blackText: true,
        },
        {
          title: 'permit-3',
          hex: '#6F71EC',
          blackText: true,
        },
        {
          title: 'permit-4',
          hex: '#50B9AD',
          blackText: true,
        },
        {
          title: 'permit-5',
          hex: '#74BD3A',
          blackText: true,
        },

        {},

        {
          title: 'dm',
          hex: '#202225',
        },
        {
          title: 'dm-primary',
          hex: '#D45679',
        },
        {
          title: 'dm-primary-hover',
          hex: '#BB2F56',
        },
        {
          title: 'dm-primary-light',
          hex: '#F892A5',
        },
        {
          title: 'dm-primary-lightest',
          hex: '#FECBDD',
          blackText: true,
        },
        {
          title: 'dm-secondary',
          hex: '#AE85CF',
        },
        {
          title: 'dm-secondary-light',
          hex: '#D6B6F0',
        },
        {
          title: 'dm-secondary-lightest',
          hex: '#FBDEFF',
          blackText: true,
        },
        {
          title: 'dm-dark',
          hex: '#FFFFFF',
          blackText: true,
        },
        {
          title: 'dm-gray-dark',
          hex: '#C2BACC',
          blackText: true,
        },
        {
          title: 'dm-gray',
          hex: '#635C67',
        },
        {
          title: 'dm-light',
          hex: '#5E5E74',
        },

        {},

        {
          title: 'warning',
          hex: '#BC7C1B',
        },
        {
          title: 'success',
          hex: '#57A818',
        },
      ],
    };
  },

  watch: {
    isDarkMode: {
      immediate: true,
      handler(isDark) {
        document.documentElement.classList.toggle('tw-dark', isDark);
      },
    },
  },
};
</script>

<style scoped>
.Break {
  flex-basis: 100%;
}
</style>
